import { KNM_EXPORT_SUCCESS } from 'CorePackage/MainModule/constants/notices';
import { ROUTE_TEMPLATES_EXPORT } from 'CorePackage/MainModule/routes/routes';
import { ImportNotification } from 'ImportPackage/MainModule/components/ImportNotification';

import { addNoticeAction } from '../actions/NoticeActions';
import { MessageTypesEnum } from '../enums/MessageTypesEnum';
import { NoticeTypesEnum } from '../enums/NoticeTypesEnum';

export const addNoticeImportNotification = (id: number) =>
  addNoticeAction({
    noticeType: NoticeTypesEnum.SUCCESS,
    messageType: MessageTypesEnum.EXPORT,
    renderContent: <ImportNotification message={KNM_EXPORT_SUCCESS} routeTo={ROUTE_TEMPLATES_EXPORT} importId={id} />,
  });
